import edu_request from '@/utils/edu_request'
import ucenter_request from '@/utils/ucenter_request'

// 获取一级分类
export function getCombinationCategory(params) {
  return edu_request({
    url: '/zkb/index/getCombinationCategory',
    method: 'get',
    params: params
  })
}
// 获取分类下的组合
export function getCombinationListByCategory(params) {
  return edu_request({
    url: '/zkb/index/getCombinationListByCategory',
    method: 'get',
    params: params
  })
}

// 首页 组合下的阶段课程
export function getStageLessonByCombinationId(params) {
  return edu_request({
    url: '/zkb/index/getStageLessonByCombinationId',
    method: 'get',
    params: params
  })
}

// 获取今日限免章节、历年真题
export function combinationFreeScheduleList(params) {
  return edu_request({
    url: '/lesson/lesson/combinationScheduleList',
    method: 'get',
    params: params
  })
}

// 组合下的课程
export function getStageLessonByCombinationLesson(params) {
  return edu_request({
    url: '/zkb/index/getStageLessonByCombinationLesson',
    method: 'get',
    params: params
  })
}

// 首页获取预测分
export function getCQPredictedScore(params) {
  return edu_request({
    url: '/subject/Zkbpro/getCQPredictedScore',
    method: 'get',
    params: params
  })
}

// 智能刷题 首页
export function getBrushHome(params) {
  return edu_request({
    url: '/subject/Zkbpro/getBrushHome',
    method: 'get',
    params: params
  })
}

// 获取做题
export function startExercise(params) {
  return edu_request({
    url: '/subject/Zkbpro/startExercise',
    method: 'get',
    params: params
  })
}

// 对答案，此题我不会
export function checkAnswer(params) {
  return edu_request({
    url: '/subject/Zkbpro/checkAnswer',
    method: 'get',
    params: params
  })
}

// 提交  交卷
export function submitAnswer(params) {
  return edu_request({
    url: '/subject/Zkbpro/submitAnswer',
    method: 'get',
    params: params
  })
}

// 获取做题结果页
export function getAnswerResult(params) {
  return edu_request({
    url: '/subject/Zkbpro/getAnswerResult',
    method: 'get',
    params: params
  })
}

// 做题结果页，知识点掌握情况
export function getAnswerKnowledge(params) {
  return edu_request({
    url: '/subject/Zkbpro/getAnswerKnowledge',
    method: 'get',
    params: params
  })
}

// 解析页接口
export function getAnswerAnalyse(params) {
  return edu_request({
    url: '/subject/Zkbpro/getAnswerAnalyse',
    method: 'get',
    params: params
  })
}

// 直接跳到结果页时，获取answer_id的接口
export function getLastAnswer(params) {
  return edu_request({
    url: '/subject/Zkbpro/getLastAnswer',
    method: 'get',
    params: params
  })
}

// 排行榜
export function getRankList(params) {
  return edu_request({
    url: '/subject/Zkbpro/getRankList',
    method: 'get',
    params: params
  })
}

// 查看有无错题
export function getErrExerciseNum(params) {
  return edu_request({
    url: '/subject/Zkbpro/getErrExerciseNum',
    method: 'get',
    params: params
  })
}

// 错题章节
export function getReport(params) {
  return edu_request({
    url: '/subject/Zkbpro/getReport',
    method: 'get',
    params: params
  })
}

// 继续做题
export function proceedExercise(params) {
  return edu_request({
    url: '/subject/Zkbpro/proceedExercise',
    method: 'get',
    params: params
  })
}

// 获取购买科目列表
export function getPayConfig(params) {
  return edu_request({
    url: '/zkb/index/getPayConfig',
    method: 'get',
    params: params
  })
}

// 获取PRO的个人中心
export function getComBination(params) {
  return ucenter_request({
    url: '/personal/myinfo/getComBination',
    method: 'get',
    params: params
  })
}

// 获取PRO的个人中心
export function getUserInfo(params) {
  return ucenter_request({
    url: '/personal/myinfo/getUserInfo',
    method: 'get',
    params: params
  })
}

export function getRow(params) {
  return ucenter_request({
    url: '/setting/bbsscore/getRow',
    method: 'get',
    params: params
  })
}

// 在微信小程序里的授权登录
export function loginWechatUser(params) {
  return ucenter_request({
    url: '/api/miniprogram/getUserInfo',
    method: 'POST',
    params
  })
}

// 获取礼品
export function exchangeGift(params) {
  return ucenter_request({
    url: '/gift/gift/exchangeGift',
    method: 'POST',
    params
  })
}
// 判断能不能购买
export function getCategroyBuy(params) {
  return edu_request({
    url: '/zkb/index/getCategroyBuy',
    method: 'GET',
    params
  })
}

// 手动删除错题
export function delErrToCorrectExercise(params) {
  return edu_request({
    url: '/subject/Zkbpro/delErrToCorrectExercise',
    method: 'get',
    params: params
  })
}

// 获取我的首页菜单
export function getMenuList(params) {
  return edu_request({
    url: '/zkb/index/getMenuList',
    method: 'GET',
    params
  })
}
// 试题纠错
export function errorFeedback(params) {
  return edu_request({
    url: '/exam/exercise/errorFeedback',
    method: 'GET',
    params
  })
}